export { default } from './MostraMesResultats';
